
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "27",
    "viewBox": "0 0 26 27"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "pewd3wsava"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "values": "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "filter": "url(#pewd3wsava)",
                "transform": "translate(-388 -707) translate(355 692)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "fill": "#000",
                    "fill-rule": "nonzero"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M11.213 20.925c.325-.338.325-1.012 0-1.35l-1.625-1.688.812-1.012 1.625 1.688c.325.337.975.337 1.3 0l3.738-3.882c.325-.337.325-1.012 0-1.35l-1.625-1.687.812-.844v-.169l1.625 1.688c.325.337.975.337 1.3 0l4.55-4.725c.325-.338.325-1.013 0-1.35l-4.55-4.725c-.325-.338-.975-.338-1.3 0l-4.387 4.725c-.488.337-.488 1.012 0 1.35l1.625 1.687-.813.844-5.688-5.737c-.325-.338-.974-.338-1.3 0l-3.737 3.88c-.325.338-.325 1.013 0 1.35L9.1 15.357l-.813 1.013v.169L6.662 14.85c-.324-.338-.974-.338-1.3 0l-4.55 4.725c-.325.338-.325 1.012 0 1.35l4.55 4.725c.325.338.976.338 1.3 0l4.55-4.725zm7.475-17.381l3.25 3.375-3.088 3.206L15.6 6.75l3.088-3.206zm-13.163 5.4l2.438-2.532L9.588 8.1 7.15 10.631 5.525 8.944zm2.438 2.531L10.4 8.944l4.875 5.062-2.6 2.532-4.713-5.063zm-1.95 11.981l-3.25-3.375 3.087-3.375 3.25 3.375-3.087 3.375zM24.05 12.994l-.65-1.181c-.162-.338-.487-.338-.813-.17-.325.17-.325.507-.162.845.813 1.35 1.3 2.868 1.3 4.556 0 1.181-.163 2.194-.65 3.206-.813 2.025-2.438 3.712-4.387 4.556-.976.338-1.95.675-3.088.675-1.137 0-2.275-.337-3.412-.844l-.976-.506c-.325-.169-.65-.169-.812.169-.162.337-.162.675.162.844.488.169.813.337 1.3.506 1.3.506 2.6.844 3.9.844 1.3 0 2.438-.338 3.575-.675 2.276-1.013 4.063-2.869 5.038-5.232.488-1.18.65-2.362.65-3.712-.162-1.181-.487-2.7-.975-3.881zm-5.363 7.087c-.325.338-.812.675-1.3 1.013-.974.506-2.112.337-3.25 0-.325-.169-.65 0-.812.337-.162.338 0 .675.325.844.162 0 .325.169.487.169 1.138.337 2.438.337 3.575-.169.65-.337 1.3-.675 1.788-1.181.488-.507.975-1.181 1.137-1.857.325-.674.488-1.35.488-2.024v-.507c0-.337-.163-.675-.163-1.012 0-.169-.162-.338-.162-.507-.163-.337-.488-.506-.813-.337-.487-.169-.65.169-.487.506.163.338.325.844.325 1.182v.506c0 .506-.162 1.181-.325 1.687s-.488 1.013-.813 1.35z",
                        "transform": "translate(33 15)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  